import { DictionaryBrand, ExtractBrand, LoadingStatusEnum, DictionaryBrandSchema, ExtractBrandSchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";

export type LoadBrandRequest = {
	forceReload?: boolean
} | void;

type LoadBrandsResponse = {
	extractBrands: ExtractBrand[];
	dictionaryBrands: DictionaryBrand[];
};

export const loadBrands = createAppAsyncThunk<LoadBrandsResponse, LoadBrandRequest>(
	"etlData/loadBrands",
	async (_, { extra, rejectWithValue, dispatch, getState }) => {
		const { selectedEtlImportUuid } = getState().etlData;

		if (!selectedEtlImportUuid) {
			return rejectWithValue("No etl import selected");
		}

		try {
			const [dictionaryBrands, extractBrands] = await Promise.all([
				extra.etlClient.findAll(DictionaryBrandSchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
				extra.etlClient.findAll(ExtractBrandSchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
			]);

			return {
				extractBrands,
				dictionaryBrands,
			}
		} catch (error) {
			dispatch(displayApiErrorToast(error));
			return rejectWithValue(error);
		}
	},
	{
		condition: (data, { getState }) => {
			if (data?.forceReload) return true;
			if (!getState().etlData.selectedEtlImportUuid) return false;
			return [LoadingStatusEnum.NotLoaded, LoadingStatusEnum.Error].includes(getState().etlData.brandsLoadingStatus);
		}
	}
);
